module.exports = __webpack_public_path__ + "static/media/audi-go-drive.229f5d59.png";